export const concat = (set, entries) =>
  Array.from(entries || []).reduce(
    (memo, entry) => memo.add(entry),
    new Set(set)
  );

export const difference = (set, entries) =>
  Array.from(entries || []).reduce((memo, entry) => {
    memo.delete(entry);
    return memo;
  }, new Set(set));

export const intersect = (target, entries) => {
  const set = new Set(target);
  return Array.from(entries || []).reduce(
    (memo, entry) => (set.has(entry) ? memo.add(entry) : memo),
    new Set()
  );
};
